import { Component, OnInit } from '@angular/core';
// import * as CryptoJS from 'crypto-js';
import { HttpGetService } from 'src/app/services/http-get.service';

@Component({
  selector: 'app-no-cash-payment',
  templateUrl: './no-cash-payment.component.html',
  styleUrls: ['./no-cash-payment.component.css']
})
export class NoCashPaymentComponent implements OnInit {
  private NO_CASH_SECRET_KEY = '6f36de3433c7ac0494afc913bfe2e345e1ad20e86820e49e30405e71453c43b0'; // Replace with your secret key
  private NO_CASH_IV = '0109b6038ff07c2ccbb3a104ac3a7ddd'; // Replace with your IV

  data;
  encryptedData;
  constructor(private api: HttpGetService) { }

  ngOnInit() {

  }


  // dynamicQR() {
  //   let data = this.enCrypt();
  //   this.api.noCashDynamicQR(data).subscribe((resp: any) => {
  //     console.log("noCashDynamicQR:::", resp);
  //   });
  // }

  // enCrypt() {

  //   let payload = {
  //     "ipAddress": "192.168.246.11",
  //     "deviceId": "3d032257-b856-4b58-b7b8-7710dfbbc990",
  //     "companyId": "4",
  //     "storeId": "4",
  //     "companyName": "Property tax Collection ",
  //     "amount": "5",
  //     "currency": "INR",
  //     "orderId": "47241020230130984994",
  //     "orderReferenceNo": "424102023013068937434",
  //     "userId": "7"
  //   };


  //   const payloadToString = JSON.stringify(payload);

  //   return this.encryptData(payloadToString);

  // }

  // encryptData(data: string): string {
  //   try {
  //     let key = CryptoJS.enc.Hex.parse(this.NO_CASH_SECRET_KEY);
  //     let iv = CryptoJS.enc.Hex.parse(this.NO_CASH_IV);

  //     let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
  //       keySize: 256 / 8,
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     });

  //     // Convert encrypted data to Base64
  //     this.encryptedData = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  //     let ivdata = CryptoJS.enc.Base64.stringify(encrypted.iv);
  //     console.log(this.encryptedData);
  //     console.log(ivdata);
  //     let requestObject2 = {
  //       merchantId: 1,
  //       encryptedData: this.encryptedData,
  //       iv: ivdata
  //     };
  //     let requestBodyJson = JSON.stringify(requestObject2);

  //     console.log(requestBodyJson);
  //     return requestBodyJson;
  //   } catch (e) {
  //     console.error(e);
  //   }
  //   return '';
  // }

  // deCrypt() {
  //   const data = {
  //     "merchantId": 1,
  //     "encryptedData": "N3YtftFocR8ft2wb52QrCx9w41WylBDJiT7fU64f58As2GNgQ5fOo3dJ0pXJU9DB5EXbICZrVLJpaRguFnLNKg5N2YIz14fE224aUhiqt8jblIwuCwt56NoXUmkdHuhaOtrdzBM7tuE2RU6O4/xDWKkTbmPq8bbvHWPWhiKOFqrmJ4/YbfzMmcvmqOKnudI3QgcxdPKogbgaD5GG5JJ0K0OEUXPAzeOjlL8y1e5ukNGd+eUycKIpXR95EtuDpbgieIgVMFkhBF1CxisAa9s2iPoWvZF2WatgHbQHBm+WBEtDnj69PeVwD1k5n7yRnr43Ae7TPdUPTCX5INrC5XcuzP8SVJ2NSCi6GoS03JSHRvtwt2ntauBhXLA4X/80b7huzNzeaeTYh11yVVv/OqgV7ExTQjvSTXPZi0tmekLrtRjCvx8DA/oq0AUDmol24yHkzFVNGPofT0R04wzEgl1N6GQ4sbW5nR4PvtSeAIh4PcS2MjKoQP/GdEagv9VVdH0rYiPCy0NAVJ7rPts2nuAkH6nDx65zlc/zcWJLoFYWLSA=",
  //     "iv": "qbsG/BgzGnlscI79WvEo/g=="
  //   };
  //   let encryptedData = data.encryptedData;
  //   let iv = data.iv;
  //   this.decryptData(encryptedData, iv);
  // }

  // decryptData(encryptedData: string, iv: string): string {
  //   try {
  //     let key = CryptoJS.enc.Hex.parse(this.NO_CASH_SECRET_KEY);
  //     let ivBytes = CryptoJS.enc.Base64.parse(iv);

  //     let decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(encryptedData) }, key, {
  //       keySize: 256 / 8,
  //       iv: ivBytes,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     });

  //     // Convert decrypted data to string
  //     let decryptedData = CryptoJS.enc.Utf8.stringify(decrypted);
  //     console.log(decryptedData);
  //     return decryptedData;
  //   } catch (e) {
  //     console.error(e);
  //   }
  //   return '';
  // }




  // // sendEncryptedDataToServer(requestData: any) {
  // //   // Use HttpClient to send the encrypted data to the server
  // //   const url = 'your-api-endpoint-url';
  // //   const headers = new HttpHeaders().set('Content-Type', 'application/json');

  // //   this.http.post(url, requestData, { headers }).subscribe(
  // //     (response) => {
  // //       // Handle the response from the server
  // //     },
  // //     (error) => {
  // //       // Handle any HTTP request errors
  // //       console.error(error);
  // //     }
  // //   );
  // // }

  // hexStringToByteArray(hex: string): Uint8Array {
  //   const len = hex.length;
  //   const data = new Uint8Array(len / 2);
  //   for (let i = 0; i < len; i += 2) {
  //     data[i / 2] = (parseInt(hex.substring(i, 2), 16) as number);
  //   }
  //   console.log("hexStringToByteArray:::" + data);
  //   return data;
  // }

  // bytesToBase64(bytes: Uint8Array): string {
  //   const binaryString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
  //   return btoa(binaryString);
  // }


  // openUPI() {
  //   const upiLink = 'upi://pay?pa=nocash.mobilenumber@icici&pn=nocash&tr=EZV2023102612381921456506&am=5&cu=INR&mc=6012';
  //   // window.open(upiLink, '_blank');
  //   window.location.href = upiLink;
  // }
}
